export default "__VITE_ASSET__CIPSUVa$__"